import React from 'react'
import SideNavbar from './helpers/SideNavbar'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPoll } from '@fortawesome/free-solid-svg-icons'


const Post = () => {
  return (
<div className="">
  <SideNavbar>
    <div className="card shadow-sm p-3 mt-3" style={{ border: 'none', backgroundColor: '#fff' }}>
      <div className="card-header" style={{ border: 'none', backgroundColor: '#fff' }}>
        <h5 className="welcome-text" style={{ fontSize: '20px', color: '#2e3192', textAlign: 'left' }}>Post Tools</h5>
      </div>
      <hr />
      <div className="container">
            <div className="row mt-2">
              {/* <div className="col-sm-12 col-xl-3 col-lg-3 col-md-3">
              <Link to="/schedule">
                <div
                  className="card shadow-lg p-3 mt-3"
                  style={{
                    border: 'none',
                    backgroundColor: '#2e3192',
                    color: '#fff',
                    borderRadius: '20px',
                    height:'200px'
                  }}
                >
                  <i className="fa fa-calendar" style={{ color: '#fff', fontSize: '30' }}></i>
                  <p className="mt-3 text-white">Plan and schedule your posts efficiently.</p>
                 
                  <b style={{ color: '#fff', fontSize: '20px' }}>Schedule Post</b>
                  
                </div>
                </Link>
              </div> */}
              
              <div className="col-sm-12 col-xl-3 col-lg-3 col-md-3">
              <Link to="/schedule-list">
                <div
                  className="card shadow-lg p-3 mt-3 d-flex flex-column"
                  style={{
                    border: 'none',
                    backgroundColor: '#2e3192',
                    color: '#fff',
                    borderRadius: '20px',
                    height:'200px'
                  }}
                >
                  <i className="fa fa-list" style={{ color: '#fff', fontSize: '20px' }}></i>
                  <div className="mt-3">
                    <p className="text-white mb-2">View and manage your scheduled posts.</p>
                    <b style={{ color: '#fff', fontSize: '20px' }}>Schedule List</b>
                  </div>
                </div>
                </Link>
              </div>
              <div className="col-sm-12 col-xl-3 col-lg-3 col-md-3">
              <Link to="/viewallpendingposts">
                <div
                  className="card shadow-lg p-3 mt-3 d-flex flex-column"
                  style={{
                    border: 'none',
                    backgroundColor: '#2e3192',
                    color: '#fff',
                    borderRadius: '20px',
                    height:'200px'
                  }}
                >
                  <i className="fa fa-hourglass-half" style={{ color: '#fff', fontSize: '20px' }}></i>
                  <div className="mt-3">
                    <p className="text-white mb-2">Pending posts awaiting approval.</p>
                    <br />
                    <b style={{ color: '#fff', fontSize: '20px' }}>Pending Posts</b>
                  </div>
                </div>
                </Link>
              </div>
              <div className="col-sm-12 col-xl-3 col-lg-3 col-md-3">
              <Link to="/viewallapprovedposts">
                <div
                  className="card shadow-lg p-3 mt-3 d-flex flex-column"
                  style={{
                    border: 'none',
                    backgroundColor: '#2e3192',
                    color: '#fff',
                    borderRadius: '20px',
                    height:'200px'
                  }}
                >
                  <i className="fa fa-check-circle" style={{ color: '#fff', fontSize: '20px' }}></i>
                  <div className="mt-3">
                    <p className="text-white mb-2">Posts that have been approved.</p>
                    <br />
                    <b style={{ color: '#fff', fontSize: '20px' }}>Approved Posts</b>
                  </div>
                </div>
                </Link>
              </div>
              <div className="col-sm-12 col-xl-3 col-lg-3 col-md-3">
              <Link to="/post-text">
                <div
                  className="card shadow-lg p-3 mt-3 d-flex flex-column"
                  style={{
                    border: 'none',
                    backgroundColor: '#2e3192',
                    color: '#fff',
                    borderRadius: '20px',
                    height:'200px'
                  }}
                >
                  <i className="fa fa-pencil" style={{ color: '#fff', fontSize: '20px' }}></i>
                  <div className="mt-3">
                    <p className="text-white mb-2">Post quickly whenever you prefer.</p>
                    <b style={{ color: '#fff', fontSize: '20px' }}>Create Post</b>
                  </div>
                </div>
                </Link>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-sm-12 col-xl-3 col-lg-3 col-md-3">
              <Link to="/KnackMoments">
                <div
                  className="card shadow-lg p-3 mt-3 d-flex flex-column"
                  style={{
                    border: 'none',
                    backgroundColor: '#2e3192',
                    color: '#fff',
                    borderRadius: '20px',
                    height:'200px'
                  }}
                >
                  <i className="fa fa-star" style={{ color: '#fff', fontSize: '20px' }}></i>
                  <div className="mt-3">
                    <p className="text-white mb-2">Curated moments to showcase.</p>
                    <br />
                    <b style={{ color: '#fff', fontSize: '20px' }}>Knack Moments</b>
                  </div>
                </div>
                </Link>
              </div>
              <div className="col-sm-12 col-xl-3 col-lg-3 col-md-3">
              <Link to="/createpoll">
                <div
                  className="card shadow-lg p-3 mt-3 d-flex flex-column"
                  style={{
                    border: 'none',
                    backgroundColor: '#2e3192',
                    color: '#fff',
                    borderRadius: '20px',
                    height:'200px'
                  }}
                >
                  <FontAwesomeIcon icon={faPoll} style={{fontSize:20, alignSelf: 'flex-start' }}/>
                  <div className="mt-3">
                    <p className="text-white mb-2">Capture opinions that matter.</p>
                    <br />
                    <b style={{ color: '#fff', fontSize: '20px' }}>Create Poll</b>
                  </div>
                </div>
                </Link>
              </div>
            </div>
          
          </div>

    </div>
  </SideNavbar>
</div>


  )
}



export default Post


